<template>
<div class="bg-gray-50">
    <h3 class="text-xl py-20 left font-semibold">Bem vindo, {{ name }}</h3>
    <div class="flex text-gray-600 font-semibold text-xs ml-[220px] mt-[-100px]">
        {{ Moment().format("DD") + " de " + Moment().format("MMMM") + " de " + Moment().format("YYYY") }}
    </div>

    <template v-if="data && data.length">

        <div class="flex w-full gap-3 mb-2">
            <div class="w-full rounded text-black px-3 py-4 flex flex-col bg-white">
                <span class="font-bold text-gray-600 text-xs">Reservas Hoje</span>
                <p class="text-xl text-left font-bold">{{data[0].quantidade_hoje}} 
                <div>
                    <div class="bg-green-300 p-3 rounded-full w-11 ml-[278px] mt-[-40px]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 text-green-700">
                            <path d="M10 9.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V10a.75.75 0 0 0-.75-.75H10ZM6 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H6ZM8 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H8ZM9.25 14a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H10a.75.75 0 0 1-.75-.75V14ZM12 11.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V12a.75.75 0 0 0-.75-.75H12ZM12 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H12ZM13.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H14a.75.75 0 0 1-.75-.75V12ZM11.25 10.005c0-.417.338-.755.755-.755h2a.755.755 0 1 1 0 1.51h-2a.755.755 0 0 1-.755-.755ZM6.005 11.25a.755.755 0 1 0 0 1.51h4a.755.755 0 1 0 0-1.51h-4Z" />
                            <path fill-rule="evenodd" d="M5.75 2a.75.75 0 0 1 .75.75V4h7V2.75a.75.75 0 0 1 1.5 0V4h.25A2.75 2.75 0 0 1 18 6.75v8.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-8.5A2.75 2.75 0 0 1 4.75 4H5V2.75A.75.75 0 0 1 5.75 2Zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75Z" clip-rule="evenodd" />
                        </svg>
                    </div>
                </div>
</p>
            </div>
            
        </div>
    
        <div class="flex w-full gap-3 mb-2">
            <div class="w-full rounded text-black px-3 py-4 flex flex-col bg-white">
                <span class="font-bold  text-gray-600 text-xs">Reservas da  Semana</span>
                <p class="text-xl text-left font-bold">{{data[0].quantity_ate_fim_semana}}
                <div>
                    <div class="bg-green-300 p-3 rounded-full w-11 ml-[278px] mt-[-40px]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 text-green-700">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
                        </svg>
                    </div>
                </div>
                        
</p>
            </div>
        </div>

        <div class="flex w-full gap-3 mb-2">
            <div class="w-full rounded text-black px-3 py-4 flex flex-col bg-white"> 
                <span class="font-bold  text-gray-600 text-xs">Horários Disponíveis na Semana</span>
                <p class="text-xl text-left font-bold">{{data[0].horarios_livres}}/{{data[0].horarios_todos}} 
                <div>
                    <div class="bg-orange-300 p-3 rounded-full w-11 ml-[278px] mt-[-40px]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 text-orange-700">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                         </svg>
                    </div>
                </div>
</p>
            </div>
        </div>

        <div class="flex w-full gap-3 mb-2">
            <div class="w-full  rounded text-black px-3 py-4 flex flex-col bg-white">
                <span class="font-bold  text-gray-600 text-xs">Reservas Comfirmadas Hoje</span>
                <p class="text-xl text-left font-bold">{{data[0].confirmados_hoje}} 
                <div>
                    <div class="bg-purple-300 p-3 rounded-full w-11 ml-[278px] mt-[-42px]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 text-purple-950">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </div>
                </div>
</p>
            </div>
        </div>

        <div>
          <div class="w-full rounded text-black px-3 py-4 flex flex-col bg-white">
                <span class="font-bold  text-gray-600 text-xs">Reservas Confirmadas semana</span>
                <p class="text-xl text-left font-bold">{{data[0].confirmados_semana}} 
                <div>
                    <div class="bg-purple-300 p-3 rounded-full w-11 ml-[278px] mt-[-42px]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 text-purple-950">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </div>
                </div>
</p>
            </div>  
        </div>

        <div class="flex w-full gap-3 mb-2">
            <div class="w-full rounded text-black px-3 py-4 flex flex-col bg-white">
                <span class="font-bold  text-gray-600 text-xs">Faturamento Hoje</span>
                <p class="text-xl text-left font-bold"> {{(data[0].valor_hoje || 0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}}
                <div>
                    <div class="bg-blue-400 p-3 rounded-full w-11 ml-[278px] mt-[-42px]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 text-blue-900">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </div>
                </div>
</p>
            </div>   
        </div>
        <div>
            <div class="w-full rounded text-black px-3 py-4 flex flex-col bg-white">
                <span class="font-bold  text-gray-600 text-xs">Faturamento da Semana</span>
                <p class="text-xl text-left font-bold">{{(data[0].valor_semana || 0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}} 
                <div>
                    <div class="bg-blue-400 p-3 rounded-full w-11 ml-[278px] mt-[-42px]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 text-blue-900">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </div>
                </div>
</p>
            </div>
        </div>


    </template>
</div> 

</template>

<script>
    import { ref, onMounted } from 'vue'
    import BookService from "../../../services/book";
    import { useAuthStore } from '../../../stores/auth'
    import Moment from 'moment'

    export default{
        //title: 'Homepage Title',
        props:['name'],

        setup(){

            const data = ref([])
            const authStore = useAuthStore()

            const getData = () =>{
                BookService.dashboard(authStore.token, Moment().startOf('week').format('YYYY-MM-DD'), Moment().endOf('week').format('YYYY-MM-DD'),Moment().format('YYYY-MM-DD'))
                .then(r=>{
                    data.value = r.data.data
                })
                .catch(e=>{
                    if(e.response.status==401){
                        logout()
                    }
                })
            }

            function logout(){
                localStorage.removeItem('auth')
                setTimeout(()=>{
                    window.location.href="/admin"
                },500)
            }

            onMounted(()=>{
                getData()
                console.log(Moment().endOf('week').format('YYYY-MM-DD'))
                console.log(Moment().startOf('week').format('YYYY-MM-DD'))
                console.log(Moment().format('YYYY-MM-DD'))

            })

            return {
                data,Moment
            }
        }
    }
</script>